import React from 'react';

import classNames from 'classnames';
import CssBaseline from '@mui/material/CssBaseline';
import Paper from '@mui/material/Paper';
import Avatar from '@mui/material/Avatar';
import Icon from '@mui/material/Icon';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import Input from '@mui/material/Input';
import InputLabel from '@mui/material/InputLabel';
import { withStyles } from '@mui/styles';
import { useTheme } from '@mui/material/styles';

import firebase from './../firebase.js';
import { getAuth, createUserWithEmailAndPassword } from "firebase/auth";
import { getDatabase,onValue, ref, orderByChild, equalTo, get, set, child, update,query,push,remove } from "firebase/database";
import $ from 'jquery';
import moment from 'moment';

const styles = theme => ({
    root: {
      width: '100%',
    },
    layout: {
        width: 'auto',
        display: 'block', // Fix IE 11 issue.
        marginLeft: useTheme().spacing(3),
        marginRight: useTheme().spacing(3),
        [useTheme().breakpoints.up(400 + useTheme().spacing(3) * 2)]: {
          width: 400,
          marginLeft: 'auto',
          marginRight: 'auto',
        },
      },
      paper: {
        marginTop: useTheme().spacing(3),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: `${useTheme().spacing(2)}px ${useTheme().spacing(3)}px ${useTheme().spacing(3)}px`,
      },
      avatar: {
        margin: useTheme().spacing(1),
        backgroundColor: useTheme().palette.secondary.main,
      },
      form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: useTheme().spacing(1),
      },
      submit: {
        marginTop: useTheme().spacing(3),
      },
      centeralign: {
        flexGrow: 1,
        textAlign: 'center',
      },
      contentbody: {
        height: '85vh',
      }
});

class Register extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
          users: [],
          userscount: 0
        }

        this.name = React.createRef();
        this.nickname = React.createRef();
        this.phone = React.createRef();
        this.email = React.createRef();
        this.password = React.createRef();
    }

    state = {
        errorlogin: '',
    }

    componentDidMount() {
      /*firebase.database().ref("/users").orderByChild('email')
        .on('value', snapshot => {*/
        const db = getDatabase();
      get(ref(db, 'users')).then((snapshot)=>{
            let userg = [];
            snapshot.forEach(child => {
            var data = child.val()
            userg.push({id: data.id,email: data.email,name: data.name,nickname: data.nickname,password: data.password,phone: data.phone,role: data.role,status: data.status,terms: data.terms,time: data.time})
            })
            this.setState({users: userg,userscount: userg.length})
            //alert(this.state.userscount)
        });

      $("div.container").css({display:'none'});
    }

    register = (e) => {
        e.preventDefault();
        
        //const auth = firebase.auth();
        try{
          const auth = getAuth();
          createUserWithEmailAndPassword(auth,this.email.current.value,this.password.current.value)
            .then(() => { 
              //setTimeout(function(){
              //try{
                this.writeMessageToDB();
              //}catch(err){
                //setTimeout(function(){ 
                //alert("Error : ", err);
                //}.bind(this), 3000);
              //}
              //}.bind(this), 10000);
              //window.location.href = "/reactchat/login"; 
            })
            .catch(error => {   
              switch(error.code) {
                case 'auth/email-already-in-use':
                      alert('Email already in use !');
                      break;
                default:
                  break;
            }
          });
        }catch(err){
            alert("Error : ", err);
        }
        //setTimeout(function(){ 
        //  window.location.href = "/reactchat/login";
        //}.bind(this), 3000);
        }

    writeMessageToDB = () => {
          var curtime = moment().format("DD/MM/YYYY HH:mm:ss");
          var name = this.name.current.value;
          var email = this.email.current.value;
          var nickname = this.nickname.current.value;
          var phone = this.phone.current.value;
          var role = 'demo';
          //alert(curtime);
          //alert(name);
          //alert(email);
          //alert(nickname);
          //alert(phone);
          //let data = ({name: name,email: email,nickname: nickname,phone: phone,time: curtime });
          //alert(JSON.stringify(data));
          //alert(JSON.stringify(firebase.database().ref("/usersdetails/a")));
          //setTimeout(function(){ 
          //var ddbbref;
          //var dbref = firebase.database().ref('/users');
          
          //dbref.push({
          //    'name': name,
          //    'email': email,
          //    'nickname': nickname,
          //    'phone': phone,
          //    'time': curtime,
          //    'role': role
          //  }).set();
          /*
          firebase.database().ref('/users').push({
              'name': name,
              'email': email,
              'nickname': nickname,
              'phone': phone,
              'time': curtime,
              'role': role,
              'terms':0,
              'password': this.password.current.value
            }).set();*/
            /*var refdb = firebase.database().ref('/users').push();
            refdb = refdb.toString().slice(-20);
            //alert(JSON.stringify(refdb));
            //alert(refdb);
            //alert(this.state.userscount);
            setTimeout(function(){ 
            let updateData = firebase.database().ref("/users").child(refdb);
            updateData.child("id").set(this.state.userscount+1);
            updateData.child("name").set(name);
            updateData.child("email").set(email);
            updateData.child("nickname").set(nickname);
            updateData.child("phone").set(phone);
            updateData.child("time").set(curtime);
            updateData.child("role").set(role);
            updateData.child("status").set("active");
            updateData.child("terms").set(0);
            updateData.child("password").set(this.password.current.value);*/

            setTimeout(function(){ 
              const db = getDatabase();
            var refdb = push(ref(db,'/users'));
              //refdb_ref = refdb.toString().slice(-20);

            set(refdb,{
              id:this.state.userscount+1,
              name:name,
              email:email,
              nickname:nickname,
              phone:phone,
              time:curtime,
              role:role,
              status:"active",
              terms:0,
              password:this.password.current.value
            });

            //alert(JSON.stringify(ddbbref));
          //}.bind(this), 3000);
          window.location.href = "/reactsopcast/";
          }.bind(this), 300);
        }

    render() {
        const { classes } = this.props;

        return (
            <div  className='col-6 mx-auto' style={{ height: '100%', position: 'relative',zIndex: '100' }}>
            <h2>Register</h2>
            <hr/>
            <React.Fragment>
            <CssBaseline />
            <main className={classNames(classes.layout,"register")}>
            <Paper className={classes.paper}>
                <Avatar className={classes.avatar}>
                <Icon className={classNames(classes.icon, 'fa fa-user-plus')} />
                </Avatar>
                <Typography component="h1" variant="h5">
                Register
                </Typography>
                <div className={classes.errorlogin}>{this.state.errorlogin}</div>
                <form className={classNames(classes.form,"register")} method="post" onSubmit={this.register.bind(this)}>
                <FormControl margin="normal" required fullWidth>
                    <InputLabel htmlFor="name">User Name</InputLabel>
                    <Input
                    type="text"
                    id="name" 
                    name="name"
                    inputRef={this.name}
                    />
                </FormControl>
                <FormControl margin="normal" required fullWidth>
                    <InputLabel htmlFor="name">Nick Name</InputLabel>
                    <Input
                    type="text"
                    id="nickname" 
                    name="nickname"
                    inputRef={this.nickname}
                    />
                </FormControl>
                <FormControl margin="normal" fullWidth>
                    <InputLabel htmlFor="name">Phone Number</InputLabel>
                    <Input
                    type="text"
                    id="phone" 
                    name="phone"
                    inputRef={this.phone}
                    />
                </FormControl>
                <FormControl margin="normal" required fullWidth>
                    <InputLabel htmlFor="email">Email Address</InputLabel>
                    <Input
                    type="email"
                    id="email" 
                    name="email"
                    inputRef={this.email}
                    />
                </FormControl>
                <FormControl margin="normal" required fullWidth>
                    <InputLabel htmlFor="password">Password</InputLabel>
                    <Input
                    name="password"
                    type="password"
                    id="password"
                    inputRef={this.password}
                    />
                </FormControl>
                <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    color="primary"
                    className={classes.submit}
                >
                    Register
                </Button>
                </form>
            </Paper>
            </main>
        </React.Fragment>
            </div>
         );
        }
    }
    
    export default withStyles(styles)(Register);
        